import { Ng2StateDeclaration } from '@uirouter/angular';
import { Transition } from '@uirouter/core';

import { ForumSummaryViewComponent } from './summary/forum.summary.component';
import { ForumReaderViewComponent } from './reader/forum.reader.component';
import { ProjectHeaderComponent } from '../../core/modules/project/projectHeader/project.header.component';

import { ForumResolvesService } from './forum-resolves.service';
import { ForumService } from './forum.service';
import { TourService } from '../../core/modules/tour/tour.service';
import { ProjectModel } from '../../core/services/project.model.service';

export const FORUM_STATES: any[] = [
    {
        name: 'home.project.summary.forum',
        redirectTo: 'home.project.summary.forum.browse',
        url: '/discussions',
        data: {
            searchContext: ['forum']
        },
        resolve: [
            {
                token: 'security',
                deps: ['project', ForumResolvesService, ProjectModel],
                resolveFn: async (project: any, forumResolvesService: ForumResolvesService, projectModel: ProjectModel) => {
                    return forumResolvesService.security(project, projectModel);
                }
            }
        ]
    },
    {
        name: 'home.project.summary.forum.browse',
        url: '?page_num&page_size',
        params: {
            page_num: {
                type: 'int',
                value: 1,
                squash: true
            },
            page_size: {
                type: 'int',
                value: 20,
                squash: true
            }
        },
        resolve: [
            {
                token: 'tour',
                deps: [ForumResolvesService, TourService],
                resolveFn: async (forumResolvesService: ForumResolvesService, tourService: TourService) => {
                    return forumResolvesService.browseTour(tourService);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: ForumSummaryViewComponent
            }
        }
    },
    {
        name: 'home.project.summary.forum.read',
        url: '/:id?thread&page_num&page_size&sort_field&sort_dir',
        reloadOnSearch: false,
        params: {
            thread: {
                type: 'int',
                value: 0,
                squash: true
            },
            page_num: {
                type: 'int',
                value: 1,
                squash: true
            },
            page_size: {
                type: 'int',
                value: 20,
                squash: true
            },
            sort_field: {
                value: 'id',
                squash: true
            },
            sort_dir: {
                value: 'asc',
                squash: true
            }
        },
        resolve: [
            {
                token: 'tour',
                deps: [ForumResolvesService, TourService],
                resolveFn: async (forumResolvesService: ForumResolvesService, tourService: TourService) => {
                    return forumResolvesService.readTour(tourService);
                }
            },
            {
                token: 'forum',
                deps: ['$transition$', 'project', ForumResolvesService, ForumService],
                resolveFn: async (transition: any, project: any, forumResolvesService: ForumResolvesService, forumService: ForumService) => {
                    const params = transition.params();
                    return forumResolvesService.getForum(params.id, forumService, project);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: ForumReaderViewComponent
            }
        }
    }
];